import { FC, useState } from 'react';
import { WrapInLayout } from '../layouts';
import { orderApi } from '../api/order.api';
import OrdersCategoryList from '../components/orders/OrdersCategoryList';
import OrdersDrilldownModal from '../components/orders/OrdersDrilldownModal';
import { DRILLDOWN_BY_DATE, SUMMARY_BY_DATE } from '../components/orders/categoryColumns';
import { IDateRange, presetRange } from '../components/orders/orderDatePresets';
import OrdersByDateCharts from '../components/orders/charts/OrdersByDateCharts';

const OrdersByDatePage: FC = () => {
  // -- Its own range, kept out of the Recent Orders filter and out of the
  // -- by-vendor one: they are different reports and sharing a range makes
  // -- each change the others.
  const [range, setRange] = useState<IDateRange>(() => presetRange('month'));

  const { data, isFetching, isError, error } = orderApi.useGetOrdersByDateQuery({
    createdFrom: range.createdFrom,
    createdTill: range.createdTill,
  });

  return (
    <WrapInLayout title="Orders By Date" layout="dashboard">
      <h1 className="text-xl font-semibold mb-3">Orders By Date</h1>
      <OrdersCategoryList
        chart={<OrdersByDateCharts rows={data} isFetching={isFetching} />}
        categoryTitle="date_create"
        columns={SUMMARY_BY_DATE}
        unit="day(s)"
        resizeStorageKey="orders-by-date"
        rows={data}
        isFetching={isFetching}
        isError={isError}
        error={error}
        range={range}
        onRangeChange={setRange}
        renderDrilldown={(row, close) => (
          <OrdersDrilldownModal
            title={`Orders on ${row.category}`}
            columns={DRILLDOWN_BY_DATE}
            createdFrom={row.category}
            createdTill={row.category}
            onClose={close}
          />
        )}
      />
    </WrapInLayout>
  );
};

export default OrdersByDatePage;
